<template>
  <div class="py-6">
    <template v-if="fetchState.pending">
      <div class="p-4"><OLoading class="w-10 mx-auto" /></div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <div v-if="state.userArticles && state.userArticles.length">
        <div class="flex flex-wrap gap-6">
          <ArticleCardProfile v-for="article in state.userArticles" :key="article._id" :article="article" />
        </div>
        <div ref="infiniteScrollRef" />
      </div>
      <div v-else class="my-8 w-full flex-col u-center">
        <OImage loading="lazy" src="/images/not-found.svg" class="max-w-56 max-h-56" />
        <div class="font-medium text-lg mt-8">{{ isMe ? $t('profile.no-content-me') : $t('profile.no-content') }}</div>
      </div>
    </template>
  </div>
</template>
<script>
import { defineComponent, ref, useFetch, useContext, useRoute } from '@nuxtjs/composition-api';
import { useInfiniteScroll } from '@/composables/useInfiniteScroll';
import { useProfile } from '@/modules/profile/state/useProfile';
import { useDevice } from '@/composables/useDevice';
import ArticleCardProfile from '@/modules/profile/components/ArticleCardProfile';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import { OLoading, OImage } from '~/modules/common/components/ui';
import { useAuth } from '~/modules/auth/state/useAuth';

export default defineComponent({
  head: {},
  components: {
    OLoading,
    OImage,
    ArticleCardProfile,
    ErrorPageLayout,
  },
  props: ['id'],
  setup(props) {
    const { isMobile } = useDevice();
    const { $error, $cache } = useContext();
    $cache('public, max-age=30');
    const { state, getUserArticles } = useProfile();

    const { user } = useAuth();
    const route = useRoute();
    const username = route.value.params.username;
    const isMe = user.value?.username === username;

    const page = ref(1);
    const userId = props.id;
    const { fetchState } = useFetch(async () => {
      try {
        await getUserArticles({ userId, page: page.value });
      } catch (error) {
        $error(error);
      }
    });

    const [infiniteScrollRef] = useInfiniteScroll(async () => {
      if (state.value.userArticlesPagination.hasNextPage) {
        page.value++;
        await getUserArticles({ userId, page: page.value });
      }
    });

    return {
      isMobile,
      state,
      infiniteScrollRef,
      fetchState,
      isMe,
    };
  },
});
</script>
